require("./app.js").main();
